import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { toggleUsernameVisibility } from 'src/store/app/actions';
import { RootState } from 'src/types/store-types';
import _styles from './UserInfo.module.scss';

export const UserInfo: FC = () => {
  const { showUsername } = useSelector((state: RootState) => state.app);
  const _toggleUsernameVisibility = useConnectedAction(toggleUsernameVisibility);
  const [idIsCopied, setIdIsCopied] = useState<boolean>(false);
  const { user } = useSelector((state: RootState) => state.user);
  const { t } = useTranslation();

  const copyUserId = (): void => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(user.id)
        .then(() => {
          setIdIsCopied(true);

          setTimeout(() => {
            setIdIsCopied(false);
          }, 1500);
        })
        .catch((err) => {
          console.error('Failed to copy text to clipboard', err);
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = user.id;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setIdIsCopied(true);

        setTimeout(() => {
          setIdIsCopied(false);
        }, 1500);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
    }
  };

  const username = useMemo(() => user?.nickname || user.username, [user?.nickname, user.username]);
  const mask = useMemo(() => username.replace(/./g, '*'), [username]);

  return (
    <div className={_styles.user_info}>
      <div className={_styles.userNameWrapper}>
        <span className={_styles.username}>{showUsername ? username : mask}</span>
        <SvgIcon
          src={`/images/${showUsername ? 'opened' : 'closed'}_eye.svg`}
          className={_styles.eye}
          onClick={_toggleUsernameVisibility}
        />
      </div>
      <div className={_styles.userId}>
        <span>
          {t('id')} {user?.id}
        </span>
        <SvgIcon src="/images/copy.svg" className={_styles.copy} onClick={copyUserId} />
        <span className={_styles.copied}>{idIsCopied && t('copied')}</span>
      </div>
    </div>
  );
};
